import React from 'react';
import { Avatar, Box, Link, Typography } from '@material-ui/core';
import AvatarPlaceholder from 'assets/img/placeholder/avatar-placeholder.svg';
import classes from './ItemNameCell.module.scss';

const ItemNameCell = ({
  image,
  itemName,
  itemTags,
  itemNo,
  hiddenImage,
  placeholder = AvatarPlaceholder,
}) => {
  return (
    <Box className={classes.itemNameCell} display='flex' gridGap={8}>
      {!hiddenImage && (
        <Avatar className={classes.avatar} src={image}>
          <img src={placeholder} alt='avatar-placeholder' />
        </Avatar>
      )}

      <Box display='flex' flexDirection='column' gridGap={8}>
        <Typography className={classes.title}>{itemName}</Typography>
        <Typography className={classes.caption} variant='caption'>
          {itemNo}
        </Typography>
        <Box display='flex' flexWrap='wrap' gridGap={8}>
          {(itemTags || []).map((tag) => (
            <Link className={classes.tag} key={tag.id} label={tag.name}>
              #{tag.name}
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ItemNameCell;
